<template>
	<AppModal v-slot="{ close }" :open="open" title="Indstillinger" image="/img/code.svg">
		<SettingsContainer />
		<button
			type="button"
			class="px-4 py-2 text-sm font-medium text-[#A0AAFE] border border-[#A0AAFE] rounded-full flex items-center justify-center flex-shrink-0 whitespace-nowrap ml-auto"
			@click="close"
		>
			Luk
		</button>
	</AppModal>
</template>

<script setup lang="ts">
import { watchDebounced } from '@vueuse/core';
import { reactive, ref } from 'vue';

import SettingsContainer from '@/components/ui/SettingsContainer.vue';
import { useUserStore } from '@/stores/user';
import { Settings } from '@/types';

import AppModal from '../AppModal.vue';

defineProps<{
	open: boolean;
}>();

const userStore = useUserStore();

const settings = reactive<Settings>({
	locale: userStore.settings.locale,
});

const saving = ref(false);

watchDebounced(
	() => settings,
	settings => {
		saving.value = true;
		userStore.saveSettings(settings).then(() => (saving.value = false));
	},
	{ debounce: 500, deep: true },
);
</script>
